import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "col-12" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "h2" }, "ファイル一覧", -1)
const _hoisted_3 = { style: {"list-style":"none"} }
const _hoisted_4 = {
  key: 0,
  style: {"font-weight":"bold"}
}
const _hoisted_5 = {
  key: 2,
  style: {"font-weight":"bold"}
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = {
  class: "col-12",
  style: {"margin-bottom":"2%"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { style: {"list-style":"none"} }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.directory.split('/'), (dir, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: dir,
          style: {"margin":"0px !important","display":"inline-block","line-height":"30px","height":"30px"}
        }, [
          (_ctx.directory==='')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "/root"))
            : (0===i)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.prevDirectory(0))),
                  style: {"cursor":"pointer"}
                }, "/root"))
              : _createCommentVNode("", true),
          (_ctx.directory.split('/').length-1==i+1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "/" + _toDisplayString(dir.replace('//','/')), 1))
            : (_openBlock(), _createElementBlock("span", {
                key: 3,
                style: {"cursor":"pointer"},
                onClick: ($event: any) => (_ctx.prevDirectory(i+1))
              }, "/" + _toDisplayString(dir.replace('//','/')), 9, _hoisted_6))
        ]))
      }), 128))
    ]),
    _hoisted_7,
    _withDirectives(_createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.downloadAll && _ctx.downloadAll(...args))),
        class: "btn btn-dark"
      }, " 一括ダウンロード "),
      _hoisted_9,
      _createElementVNode("small", null, " ※ファイルは " + _toDisplayString(_ctx.MAX_DOWNLOAD_FILE_CHUNK) + " 件ごとに分割してダウンロードされます。 ", 1)
    ], 512), [
      [_vShow,  _ctx.directory . split('/').length  > 2 ]
    ]),
    _hoisted_10,
    _createElementVNode("ul", _hoisted_11, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentDirectory, (obj, key) => {
        return (_openBlock(), _createElementBlock("li", { key: key }, [
          (obj=='file')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                style: {"font-size":"20px"},
                href: _ctx.getDownloadURL(key),
                download: ""
              }, _toDisplayString(key), 9, _hoisted_12))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                onClick: ($event: any) => (_ctx.nextDirectory(key) ),
                style: {"font-size":"20px","cursor":"pointer"}
              }, _toDisplayString(key), 9, _hoisted_13))
        ]))
      }), 128))
    ])
  ]))
}